/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leads_EmptyInputs */

const cs_leads_empty = /** @type {(inputs: Leads_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné leady.`)
};

const en_leads_empty = /** @type {(inputs: Leads_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No leads yet.`)
};

/**
* | output |
* | --- |
* | "No leads yet." |
*
* @param {Leads_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const leads_empty = /** @type {((inputs?: Leads_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leads_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leads_empty(inputs)
	return cs_leads_empty(inputs)
});